"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(data, config) {
  return "<div class=\"".concat(config.tagboard["class"], "\" tgb-embed-id=\"").concat(data.id, "\"></div>");
};

exports["default"] = _default;